import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import ComercioExteriorPropietarioForm from './ComercioExteriorPropietarioForm';
import ComercioExteriorPropietarioList from './ComercioExteriorPropietarioList';

class ComercioExteriorPropietarioManager extends Component {
  state = {};

  handleOnAdd = (data) => {
    const { Propietario = [] } = this.props.data;

    const newData = Propietario.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    this.props.onChange({
      ...this.props.data,
      Propietario: data
    });
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  render() {
    const { data } = this.state;
    const { Propietario = [] } = this.props.data;

    return (
      <div className="pb-4">
        <div>
          <strong className="text-black text-upper">Propietario</strong>
        </div>

        <div className="section">
          <div className="pt-2">
            <ComercioExteriorPropietarioForm
              data={ data }
              onAdd={ this.handleOnAdd }
            />
          </div>

          <div className="pt-2">
            <ComercioExteriorPropietarioList
              data={ Propietario }
              onEdit={ this.handleOnEdit }
              onChange={ this.handleOnListChange }
            />
          </div>
        </div>
      </div>
    )
  }
}

export default ComercioExteriorPropietarioManager;